import { Component, inject } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { MemberAuthViewModel } from '../../../../viewModels/member-auth-view-model';
import { ActivatedRoute, Router } from '@angular/router';
import { VerifyEmailRequest } from '../../../../../../models/users/requests/verify-email-request';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { PortalService } from '../../../../../../services/portal/portal.service';
import { AssetSize } from '../../../../../../models/enum/dto/asset-size.enum';
import { createVerificationCodeFormGroup } from '../../../../forms/verification-code-form-group';

@Component({
  selector: 'app-member-enter-email-verification',
  templateUrl: './member-enter-email-verification.component.html',
  styleUrls: ['./member-enter-email-verification.component.scss', '../../auth.component.scss']
})
export class MemberEnterEmailVerificationComponent extends BaseComponent {
  public viewModel = inject(MemberAuthViewModel);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private portalService = inject(PortalService);

  constructor() {
    super();
  }

  private _userEmail = new BehaviorSubject<string>('');
  public readonly userEmail$ = this._userEmail as Observable<string>;

  public formGroup = createVerificationCodeFormGroup(null);
  public formSubmitted = false;

  private listenToQueryParams = this.route.queryParams.subscribeWhileAlive({
    owner: this,
    next: params => {
      const email = decodeURIComponent(decodeURIComponent(params?.Email || params?.email || ''));
      if (!!email) {
        this._userEmail.next(email);
        this.viewModel.setNewMemberEmail(email);
        this.router.navigate([], { queryParams: {}, replaceUrl: true, relativeTo: this.route }).then();
      }
    }
  });

  setupBindings(): void {}

  setupViews(): void {}

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.userEmail$.once(email => {
      this.viewModel.verifyMemberEmail(new VerifyEmailRequest(email, this.formGroup.controls.code.value));
    });
  }

  public resendCode(): void {
    combineLatest([this.userEmail$, this.portalService.portalType$])
      .pipe(take(1))
      .subscribe(([email, portalType]) => this.viewModel.resendMemberEmailVerificationCode(email, portalType));
  }

  protected readonly AssetSize = AssetSize;
}
